export enum DatadogRumUserJourneyEnum {
  CREATE_BOOKING = 'create-booking',
}

export enum DatadogRumEnum {
  MODE = 'mode',
  HAS_ERROR = 'has_error',
  PATH_ERROR = 'path_error',
}
